import chatStore from '../../store/ChatStore';
import { WChatEvent } from './WChatEvent';

export class WTargetEmojiEvent extends WChatEvent {
  targetPid: string;

  constructor(event: WTargetEmojiEvent) {
    super(event);
    this.targetPid = event.targetPid;
  }

  applyWebsocketChanges = (): Promise<void> => {
    chatStore.addTargetEmojiMessage({ ...this });
    return Promise.resolve();
  };
}
